"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithLanguages = exports.PAGE_TYPE_404 = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const headers_1 = require("./headers");
const lang_context_1 = require("./lang.context");
const lang_util_1 = require("./lang.util");
exports.PAGE_TYPE_404 = `PAGE_404`;
function appWithLanguages(options = {}) {
    const { addCanonical = true } = options;
    return function (WrappedAppComponent) {
        function AppWithLanguageUrls(props) {
            var _a;
            const tr = (0, next_i18next_1.useTranslation)();
            const languages = (0, react_1.useMemo)(() => (0, lang_util_1.defineLanguages)(props.pageProps, addCanonical, tr.i18n.language), [props.pageProps, tr.i18n.language]);
            // @ts-ignore
            const page = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.page;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                addCanonical && page !== exports.PAGE_TYPE_404 ? (react_1.default.createElement(headers_1.Headers, { canonical: languages.canonical, alternativeUrls: languages.alternativeUrls })) : null,
                react_1.default.createElement(lang_context_1.LanguagesContext.Provider, { value: { urls: languages.urls, canonical: languages.canonical } },
                    react_1.default.createElement(WrappedAppComponent, Object.assign({}, props)))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithLanguageUrls, WrappedAppComponent);
    };
}
exports.appWithLanguages = appWithLanguages;
//# sourceMappingURL=lang-provider.js.map